import { render, staticRenderFns } from "./serveList.vue?vue&type=template&id=e538ce9a&"
import script from "./serveList.vue?vue&type=script&lang=js&"
export * from "./serveList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports